// 【公共组件】版权信息
export default {
   'copyright.desc1': 'Alwayscontrol系统版权所有者：旭衡电子（深圳）有限公司',
   'copyright.desc2': '网站备案信息：粤ICP备2021169764号',
   'copyright.desc3': '联系方式：xuheng@alwayscontrol.com.cn',
}
 